<template>
  <div class="screen page customers b-soft">
    <div class="grid">
      <section class="layout">
        <div class="container">
          <div class="row h-items-center">
            <div class="col-12 box-container b-white moves-container no-select">
              <ul v-if="clientes.length" class="list-container container">
                <li v-for="cliente in clientes" :key="cliente.id" class="row v-items-center">
                  <div class="col" v-on:click.prevent="goTo('/cliente/'+cliente.id)">
                    <div class="container">
                      <div class="row v-items-center">
                        <div class="col-auto">
                          <span class="icon-list" v-bind:style="{'background-color': cliente.color}">
                            <b class="t-18-px">{{cliente.nombre | initialText}}</b>
                          </span>
                        </div>
                        <div class="col">
                          <p class="t-complementary t-14-px">
                            <span v-if="cliente.empresa">{{cliente.empresa | cutText}}</span> <span v-if="cliente.nombre"> | {{cliente.nombre | cutText}}</span> <span v-if="cliente.contacto"> | {{cliente.contacto | cutText}}</span>
                            <br>
                            <span class="t-upper t-10-px t-base" v-if="cliente.fecha_creacion">Creado: {{cliente.fecha_creacion.seconds | beautyFormatDate}}</span> <span class="t-upper t-10-px t-base" v-if="cliente.usuario_creador"> Por {{cliente.usuario_creador}}</span><span class="t-upper t-10-px t-base separador-fechas" v-if="cliente.fecha_creacion && cliente.fecha_modificacion"> / </span><span class="t-upper t-10-px t-base" v-if="cliente.fecha_modificacion">Editado: {{cliente.fecha_modificacion.seconds | beautyFormatDate}}</span> <span class="t-upper t-10-px t-base" v-if="cliente.usuario_editor"> Por {{cliente.usuario_editor}}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-auto">
                    <a href="#" class="t-complementary" v-on:click.prevent="deleteElement('clientes', cliente.id)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                 </li>
              </ul>
              <p v-else class="t-center">
                <i class="fas fa-sad-cry t-48-px"></i>
                <br>
                <br>
                No se encontraron clientes
              </p>
            </div>
          </div>
        </div>
      </section>
      <GetFooter />
    </div>
  </div>
</template>

<script>
import GetFooter from '@/components/footer.vue'
import router from '@/router'
import { db } from '@/firebase'
export default {
  name: 'app',
  components: {
    GetFooter
  },
  data() {
    return {
      clientes: []
    }
  },
  firestore () {
    return {
      clientes: db.collection('clientes').orderBy('nombre', 'asc')
    }
  },
  methods: {
    goTo (url){
      router.push({path: url})
    },
    deleteElement(collection, id){
      if(window.confirm('¿Estás Seguro? Esto eliminará el elemento permanentemente.')){
        db.collection(collection).doc(id).delete().then(function() {
          console.log('Document successfully deleted!')
        }).catch(function(error) {
          alert('Error de ejecución')
          console.error('Error removing document: ', error)
        })
      }
    }
  }
}
</script>